export enum CommonEvents {
  SAVE_OFFER = 'save offer',
  DESTROY = 'destroy',
  INITIALIZED = 'initialized',
}

export default CommonEvents;
